import { getAxiosInstance } from '../client';
/** Typed API functions for office staff */
export const staffQueries = {
    /** GET /offices/:officeId/staff/hidePending */
    getByOfficeHidePending: (officeId) => getAxiosInstance()
        .get(`/offices/${officeId}/staff/hidePending`)
        .then((r) => r.data),
    /** GET /offices/:officeId/staff */
    getByOffice: (officeId) => getAxiosInstance()
        .get(`/offices/${officeId}/staff`)
        .then((r) => r.data),
    /** GET /offices/:officeId/staff/q/:query */
    searchByOffice: (officeId, q) => getAxiosInstance()
        .get(`/offices/${officeId}/staff/q/${q}`)
        .then((r) => r.data),
};
/** Query keys for office staff list - use with TanStack Query */
export const staffKeys = {
    all: () => ['staff'],
    byOffice: (officeId) => ['staff', 'office', officeId],
    searchByOffice: (officeId, q) => ['staff', 'office', officeId, 'search', q],
};
//# sourceMappingURL=staff.queries.js.map